module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point01_01_winter-d6b74fc590659568b2b8200ffbb5fb7e.jpg";